/* Knife Comparison — rail Previous/Next buttons and the two-product picker for the detailed comparison on small screens.
   The overview, links and the native <details> work without this file. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 1023px)');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(sec) {
    if (sec.__kc) return; sec.__kc = true;
    var rail = sec.querySelector('[data-kc-rail]'), nav = sec.querySelector('[data-kc-nav]');
    var prev = sec.querySelector('[data-kc-prev]'), next = sec.querySelector('[data-kc-next]');
    if (rail && nav && prev && next) {
      function step(dir) { var item = rail.querySelector('[data-kc-item]'); var w = item ? item.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8; rail.scrollBy({ left: dir * w, behavior: rm.matches ? 'auto' : 'smooth' }); }
      function update() { nav.hidden = !mq.matches; prev.disabled = rail.scrollLeft <= 4; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4; }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', update, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', update); else window.addEventListener('resize', update);
      update();
    }
    var pick = sec.querySelector('[data-kc-pick]'), table = sec.querySelector('[data-kc-table]');
    if (pick && table) {
      var a = pick.querySelector('[data-kc-sel="a"]'), b = pick.querySelector('[data-kc-sel="b"]');
      function apply() {
        var va = a.value, vb = b.value;
        table.querySelectorAll('[data-col]').forEach(function (cell) {
          cell.classList.toggle('is-a', cell.getAttribute('data-col') === va);
          cell.classList.toggle('is-b', cell.getAttribute('data-col') === vb);
        });
        /* never allow the same knife twice */
        [].forEach.call(a.options, function (o) { o.disabled = o.value === vb; });
        [].forEach.call(b.options, function (o) { o.disabled = o.value === va; });
      }
      a.addEventListener('change', apply); b.addEventListener('change', apply);
      pick.hidden = false; apply();
    }
  }
  /* Currency guard: the section's prices come from Liquid in the market currency of the request. If the HTML was
     rendered in a different currency from the page (Shopify.currency.active) — a stale cached render, for instance —
     fetch this section again via the Section Rendering API and swap it in. Skipped inside the theme editor, where a
     re-render would discard unsaved settings; the editor's own market selector controls the preview currency there. */
  function reconcile(sec) {
    var page = window.Shopify && Shopify.currency && Shopify.currency.active, have = sec.getAttribute('data-kc-currency'), id = sec.getAttribute('data-kc-section');
    if (!page || !have || !id || page === have || sec.__kcRefetched || (window.Shopify && Shopify.designMode) || !window.fetch) return;
    sec.__kcRefetched = true;
    fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-kc]');
        if (!fresh || fresh.getAttribute('data-kc-currency') !== page) return;
        fresh.__kcRefetched = true;
        sec.parentNode.replaceChild(fresh, sec);
        init(fresh);
      })
      .catch(function () {});
  }
  function initAll() { document.querySelectorAll('[data-kc]').forEach(function (sec) { init(sec); reconcile(sec); }); }
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-kc]'); if (s) { s.__kc = false; init(s); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
